"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../theme");
exports.useStyles = (0, react_jss_1.createUseStyles)({
    component: {
        display: "flex",
        flexDirection: "column",
        gap: (0, theme_1.space)(8),
    },
    time: {
        display: "flex",
        flexWrap: "wrap",
        gap: (0, theme_1.space)(8),
    },
    deleteFilter: {
        width: "100%",
        "--on-button-color": theme_1.colors.delete,
        "--on-button-hover-color": theme_1.colors.delete,
    }
});
